module.exports = "/_next/static/images/block3-5fb37224e2139423719d0e2d916ab189.svg";